import React from 'react';
import { Tooltip, Icon } from 'antd';
import { ENV } from '@/services/utils';

const hostName = {
  test: 'test.m.xiaoyuanhao.com',
  dev: 'test.m.xiaoyuanhao.com',
  production: 'm.xiaoyuanhao.com',
};

const columns = [
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    fixed: 'left',
    render: text => {
      if (text.length <= 20) {
        return <span>{text}</span>;
      }
      return (
        <Tooltip placement="top" title={text}>
          <span>{text.substring(0, 20)}...</span>
        </Tooltip>
      );
    },
  },
  {
    title: '发布组织',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  { title: '通讯员', dataIndex: 'publishUserName', key: 'publishUserName' },
  {
    title: '所在省',
    dataIndex: 'region',
    key: 'region',
  },
  {
    title: '所在市',
    dataIndex: 'city',
    key: 'city',
  },
  {
    title: '所在区',
    dataIndex: 'area',
    key: 'area',
  },
  {
    title: '学校性质',
    dataIndex: 'orgProperty',
    key: 'orgProperty',
  },
  {
    title: '组织性质',
    dataIndex: 'orgType',
    key: 'orgType',
  },
  {
    title: '学段',
    dataIndex: 'managementEntitySign',
    key: 'managementEntitySign',
  },
  {
    title: (
      <div>
        阅读次数
        <Tooltip placement="top" title="阅读次数为用户查看文章次数的总和">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'clickCounts',
    key: 'clickCounts',
  },
  {
    title: (
      <div>
        点赞数
        <Tooltip placement="top" title="点赞数为用户点赞的总次数，外链文章阅读点赞次数暂无法统计">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'praiseCounts',
    key: 'praiseCounts',
  },
  {
    title: '详情',
    dataIndex: 'newsId',
    key: 'newsId',
    fixed: 'right',
    render: text => {
      return (
        <a
          onClick={() =>
            window.open(`//${hostName[ENV]}/micro/app/micrositeV4/articleDetail?id=${text}`)
          }
        >
          详情
        </a>
      );
    },
  },
];

export { columns };
